import React from 'react';
import { Nav } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { capitalize } from 'shared/helpers/utils';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { useAppContext } from 'providers/AppProvider';
import { useTranslation } from 'react-i18next';

interface MenuItem {
  name: string;
  icon: string;
  path: string;
  active: boolean;
}

interface LayoutSidebarMenuProps {
  routes: MenuItem[];
  onLinkClick?: () => void;
}

const LayoutSidebarMenu = ({ routes, onLinkClick }: LayoutSidebarMenuProps) => {
  const { t } = useTranslation();
  const {
    config: { isNavbarVerticalCollapsed },
  } = useAppContext();

  const handleLinkClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <>
      {routes.map((route) => (
        <Nav.Item key={route.name} as="li">
          <NavLink
            to={route.path}
            className={({ isActive }) =>
              classNames('nav-link', { active: isActive })
            }
            onClick={handleLinkClick}
          >
            <span className="nav-link-icon">
              <FeatherIcon icon={route.icon} size={16} />
            </span>
            <span className="nav-link-text">
              {t(route.name)}
            </span>
          </NavLink>
        </Nav.Item>
      ))}
    </>
  );
};

export default LayoutSidebarMenu;
